export const ERROR = 'ERROR'
export const WARNING = 'WARNING'
export const STATUS = 'STATUS'
export const PROCESS = 'PROCESS'
export const PROGRESS = 'PROGRESS'



// WEBPACK FOOTER //
// ./src/app/component/notification/type.js